/* globals wx */
import React, { Component } from "react";
import PropTypes from "prop-types";
import VisibilitySensor from "react-visibility-sensor/visibility-sensor";
import api from "../utils/api";
import { getAnalyticsByAttr, getAnalyticsByLook, getProductAnalytics, sendProductAnalytics } from "../utils/analytics";
import proxy from "../proxy";
import cookies from "../utils/cookies";
import g from "../utils/globals";
import { isNavigable, urlTo } from "../utils/urls";

class Link extends Component {
  constructor(props) {
    super(props);
    this.analytics = this.props.analytics || null;
    this.children = null;
    this.firstVisible = true;
    this.myRef = React.createRef();
    this.analyticPerViewSent = false;
    this.className = this.props.className ? `${this.props.className} wrapper` : `wrapper`;

    if (this.props.dataAttrs["data-product"]) {
      this.className += " _product-link";
    } else if (g.channels.desktop && this.props.dataAttrs["data-layout"] === "products-category-view") {
      this.className += " _product-link";
    } else if (this.props.dataAttrs["data-layout-mobile"] === "products-category-view") {
      this.className += " _product-link";
    } else if (this.props.dataAttrs["data-category"]) {
      this.className += " _category-link-wrapper";
    }

    this.anchor = props.href.substr(0, 1) === "#" ? this.props.href.replace("#", "") : null;
  }

  componentWillMount = () => {
    // create automatic analytics in case are not specified
    // if we receive dataAttrs as data-category or data-product
    if (Object.keys(this.props.dataAttrs).length > 0 && this.props.children && !this.analytics) {
      this.children = Object.assign({}, this.props.children);
      if (this.props.dataAttrs?.product) {
        this.productAnalytics = getProductAnalytics(this.props.dataAttrs);
      } else {
        if (this.props.children instanceof Array) {
          this.children = this.props.children
            .filter(x => x)
            .find(x => {
              return x.type === "img" || (x.props && x.props.module && x.props.module === "Img");
            });
        } else if (this.children.props && !this.children.props.module) {
          this.children.props = this.children._owner.pendingProps;
        }
        if (this.children) {
          if (this.children.props.id && this.children.props.id.indexOf("look") > -1) {
            this.analytics = getAnalyticsByLook(this.children.props, this.props.dataAttrs);
          } else {
            this.analytics = getAnalyticsByAttr(this.children.props, this.props.dataAttrs, this.props.position);
          }
        }
      }
    }
  };

  componentDidMount = () => {
    if (this.myRef.current && this.myRef.current.classList.contains("_product-link") && this.myRef.current.getAttribute("href")) {
      this.myRef.current.addEventListener(
        "mousedown",
        proxy.proxy("BundlesHandler#click", e => {
          const clicked = e.target.closest("a");
          const href = clicked.getAttribute("href") || clicked.getAttribute("data-url");
          if (href) {
            const regex = href.match(/p(\d+)/);
            let id = clicked.getAttribute("data-product");

            if (!id && regex && regex.length) id = regex[1];

            if (e.which === 1) {
              cookies.store("mkt-last-bundle-id", id);
            }
          }
        })
      );
    }
    const idElement = cookies.read("mkt-last-bundle-id");
    if (idElement) {
      const elm = document.querySelector(`[id="${idElement}"]`) || document.querySelector(`[data-product="${idElement}"]`);
      if (elm) {
        setTimeout(() => {
          elm.scrollIntoView({
            block: "start",
            inline: "nearest",
          });
          cookies.store("mkt-last-bundle-id", "");
        }, 100);
      }
    }
  };

  openMenu = () => {
    // IN EDIT MODE THE MENU IS NOT OPENED
    if (!document.getElementById("visual-editor-styles")) {
      const categoryId = this.props.dataAttrs["data-category"] || g.categoryId;
      api.mktTrigger("MENU_ITEM_SELECTION_REQUESTED", {
        categoryId,
      });
    }
  };

  triggerAnalytics = () => {
    if ((this.analytics || this.productAnalytics) && !this.myRef.current.classList.contains("no-track")) {
      if (this.props.carousel) {
        let dimension80 = "Subhome";
        if (this.myRef.current.classList.contains("_product-link")) {
          dimension80 = "Product_List";
        }
        this.analytics.action = "Click_banner";
        this.analytics.label = this.analytics.eec.name;
        this.analytics.dimension80 = dimension80;
      }
      if (this.productAnalytics) {
        sendProductAnalytics("PRODUCT_LIST_PRODUCT_LINK_CLICK", this.productAnalytics.click);
      } else {
        api.trackEvent(this.analytics);
      }
    }
  };

  // eslint-disable-next-line max-statements
  handleClick = e => {
    this.triggerAnalytics();
    if (this.props.dataAttrs["data-category"] && !g.channels.minip && !g.channels.apps) {
      e.preventDefault();
      const categoryId = this.props.dataAttrs["data-category"];
      if (isNavigable(categoryId) && !this.props.openMenu) {
        window.location.href = urlTo("category", categoryId);
      } else {
        this.openMenu();
      }
      return;
    }

    if (this.props.onclick) {
      e.preventDefault();
      this.props.onclick(e);
      return;
    }

    if (this.anchor) {
      e.preventDefault();
      const target = document.getElementById(this.anchor);
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    if (g.channels.minip) {
      e.preventDefault();
      wx.miniProgram.navigateTo({ url: this.props.href });
    }
  };

  checkVisible = isVisible => {
    if (
      isVisible &&
      (this.analytics || this.productAnalytics?.impression) &&
      !this.analyticPerViewSent &&
      this.props.analyticsPerView &&
      !this.props.carousel
    ) {
      const height = this.myRef.current.getBoundingClientRect().height / 2;
      const offsetTop = this.myRef.current.offsetTop;
      const scrollY = window.scrollY || window.pageYOffset;
      const fiftyVisible = scrollY - offsetTop < height;
      if (fiftyVisible) {
        if (this.props.dataAttrs?.product) {
          this.props.addProductImpressionsToSend(this.props.dataAttrs.product.id, this.productAnalytics.impression);
        } else {
          const analyticPerView = Object.assign({}, this.analytics, {
            action: "Banner_impression",
          });
          if (analyticPerView.origin) delete analyticPerView.origin;
          if (document.querySelector(".sendImpressionsScroll")) {
            api.trackEvent(analyticPerView);
          }
        }
        this.analyticPerViewSent = true;
      }
    }
    if (isVisible && this.firstVisible) {
      this.firstVisible = false;
    }
  };

  render = () => {
    const hasHref = this.props.href || this.anchor;
    const Element = !hasHref ? "div" : "a";

    const hrefAttrs = {};
    if (this.anchor) hrefAttrs.href = this.props.anchor;
    if (this.props.link) hrefAttrs.href = this.props.link;
    if (this.props.href) hrefAttrs.href = this.props.href;
    if (this.props.href) {
      hrefAttrs.href = this.props.href;
      hrefAttrs["data-url"] = this.props.href;
    }

    return (
      <VisibilitySensor delayedCall={true} onChange={isVisible => this.checkVisible(isVisible)}>
        <Element
          {...hrefAttrs}
          style={this.props.style || this.props.styles}
          className={this.className}
          id={this.props.id ? this.props.id : null}
          {...this.props.dataAttrs}
          onClick={hasHref && this.handleClick}
          ref={this.myRef}
        >
          {this.props.children}
        </Element>
      </VisibilitySensor>
    );
  };
}

Link.defaultProps = {
  href: "",
  attrs: {},
  dataAttrs: {},
  index: 0,
  analytics: null,
  analyticsPerView: true,
  customProps: {},
};

Link.propTypes = {
  href: PropTypes.string.isRequired,
  attrs: PropTypes.object,
  dataAttrs: PropTypes.object,
  onclick: PropTypes.func,
  index: PropTypes.number,
  analytics: PropTypes.object,
  analyticsPerView: PropTypes.bool,
};

export default Link;
